import { mediaRepo } from '../../db/mediaRepo';
import type { ContentRow } from '../../types/content';
import type { MediaRenderer, RenderSlot } from './types';
import { cssObjectFit, showOnly } from './util';

// Shows a downloaded image blob. Ported from ImageFrame.
export const imageRenderer: MediaRenderer = {
  type: 'image',
  needsMedia: true,

  async prepare(slot: RenderSlot, content: ContentRow): Promise<boolean> {
    const url = await mediaRepo.objectUrl(content.fileName);
    if (!url) return false;
    slot.objectUrl = url;

    showOnly(slot, 'img');
    slot.img.style.objectFit = cssObjectFit(content.resizeMode);

    return await new Promise<boolean>((resolve) => {
      slot.img.onload = () => resolve(true);
      slot.img.onerror = () => {
        // Corrupted cached blob (e.g. unclean power-off): drop it so the next
        // sync re-downloads a good copy.
        void mediaRepo.delete(content.fileName);
        resolve(false);
      };
      slot.img.src = url;
    });
  },

  // Image is fully loaded after prepare(); nothing to start.
  async activate(): Promise<boolean> {
    return true;
  },
};
